import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { TableCell, TableRow } from "@ps-design-system/components/Table";
import { Text } from "@ps-design-system/components/Text";
import TrashIcon from "@ps-design-system/icons/Trash/Trash20";

type DateRateTableRowProps = {
  date: string;
  hourlyRate: string;
  onDeleteClick: () => void;
};

/** One date rate in the table: its date, hourly price and a delete button. */
const DateRateTableRow = ({
  date,
  hourlyRate,
  onDeleteClick,
}: DateRateTableRowProps) => (
  <TableRow
    className="tw-border-0 tw-border-b tw-border-solid tw-border-gray-400 last:tw-border-b-0"
    data-testid="date-rate-table-row"
  >
    <TableCell className="tw-align-middle">
      <Text>{date}</Text>
    </TableCell>
    <TableCell className="tw-align-middle tw-text-right">
      <Text>{hourlyRate}</Text>
    </TableCell>
    <TableCell className="tw-align-middle tw-py-8 tw-text-right">
      <Button
        iconOnly
        onClick={onDeleteClick}
        testId="date-rate-table-delete"
        variant="ghost"
      >
        <TrashIcon />
        <span className="tw-sr-only">
          <FormattedMessage
            id="hosting.date_rate_table.delete_button"
            defaultMessage="Delete rate"
          />
        </span>
      </Button>
    </TableCell>
  </TableRow>
);

export { DateRateTableRow };
